export const getters = {
  systemTrips: state => state.trips,
  Trip: state => state.systemTrip
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/trips/getters.js